import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Container = styled.span`
  display: flex;
  gap: var(--cc_size_spacing_m);
  align-items: center;
  padding: var(--cc_size_spacing_m) 0;
  ${(props) =>
    !props.withoutBorder
      ? css`
          border-block-end: var(--cc_size_border_width_s) solid
            var(--cc_color_border_default);
        `
      : null}
`;
const ContentPrimary = styled.span`
  flex: 1;
  min-width: 1px;
`;
const ContentBeforeAfter = styled.span`
  flex-shrink: 0;
`;

const ListItem = ({
  className,
  contentBefore,
  contentPrimary,
  contentAfter,
  style,
  withoutBorder,
}) => {
  return (
    <Container
      className={className}
      style={style}
      withoutBorder={withoutBorder}
      contentBefore={contentBefore}
      contentAfter={contentAfter}
    >
      {contentBefore ? (
        <ContentBeforeAfter>{contentBefore}</ContentBeforeAfter>
      ) : null}
      {contentPrimary ? (
        <ContentPrimary>{contentPrimary}</ContentPrimary>
      ) : null}
      {contentAfter ? (
        <ContentBeforeAfter>{contentAfter}</ContentBeforeAfter>
      ) : null}
    </Container>
  );
};

ListItem.propTypes = {
  className: PropTypes.string,
  contentBefore: PropTypes.node,
  contentPrimary: PropTypes.node,
  contentAfter: PropTypes.node,
  style: PropTypes.object,
  withoutBorder: PropTypes.bool,
};

ListItem.defaultProps = {
  className: undefined,
  contentBefore: undefined,
  contentPrimary: undefined,
  contentAfter: undefined,
  style: undefined,
  withoutBorder: false,
};

export default ListItem;
